import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { CustomiconComponent } from 'src/app/_metronic/layout/components/customicon/customicon.component';

@Component({
  selector: 'app-snackbar',
  standalone: true,
  imports: [CommonModule, MatIcon, CustomiconComponent, MatIconModule ],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss'
})
export class SnackbarComponent implements OnInit {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, private snackBarRef: MatSnackBarRef<SnackbarComponent> ) {
  }

  ngOnInit() {

  }

  get getIcon() {
    switch (this.data.snackType) {
      case 'Success':
        return 'snackbar-success';
      case 'Error':
        return 'snackbar-error';
      case 'Warn':
        return 'snackbar-info';
      case 'Warn 2':
        return 'custom-snackbar-warning';
      case 'Info':
        return 'snackbar-info';
    }
  }

  get getActionIcon() {
    switch (this.data.action) {
      case 'Close':
        return 'snackbar-round-close';
    }
  }

  close() {
    this.snackBarRef.dismiss();
  }

}
